module.exports = __webpack_public_path__ + "img/first-author-only-rc.be76e818.jpg";